import { render, staticRenderFns } from "./RightWrap1.vue?vue&type=template&id=0ccdad4a&scoped=true"
import script from "./RightWrap1.vue?vue&type=script&lang=js"
export * from "./RightWrap1.vue?vue&type=script&lang=js"
import style0 from "./RightWrap1.vue?vue&type=style&index=0&id=0ccdad4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccdad4a",
  null
  
)

export default component.exports